module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av145-90bf3997b229a868847ea68295e0dc27.jpg";